module.exports = __webpack_public_path__ + "25f6c60e45d0304eac808d0c9080d986.png";